import { ActiveFilter } from './active-filter';
import { ActiveFiltersProps } from './types';

export function ActiveFilters({ active, onRemove }: ActiveFiltersProps) {
  if (!active.length) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {active.map((item) => (
        <ActiveFilter key={item.id} item={item} onRemove={onRemove} />
      ))}
    </div>
  );
}
